(function () {
  function formatMoney(symbol, value) {
    const n = Number(value || 0);
    return `${symbol}${Math.round(n)}`;
  }

  function initOne(root) {
    const max = Number(root.dataset.max || 0);
    const symbol = root.dataset.currency || '$';

    const minRange = root.querySelector('.facet-price-slider__thumb--min');
    const maxRange = root.querySelector('.facet-price-slider__thumb--max');

    const realMin = root.querySelector('.facet-price-slider__real--min');
    const realMax = root.querySelector('.facet-price-slider__real--max');

    const minOut = root.querySelector('[data-min]');
    const maxOut = root.querySelector('[data-max]');

    if (!minRange || !maxRange || !realMin || !realMax) return;

    minRange.max = String(max);
    maxRange.max = String(max);

    function clampAndPaint() {
      let a = Number(minRange.value || 0);
      let b = Number(maxRange.value || 0);

      if (a > b) a = b;
      if (b < a) b = a;

      a = Math.max(0, Math.min(a, max));
      b = Math.max(0, Math.min(b, max));

      minRange.value = String(a);
      maxRange.value = String(b);

      const minPct = max ? (a / max) * 100 : 0;
      const maxPct = max ? (b / max) * 100 : 100;
      root.style.setProperty('--min-pct', `${minPct}%`);
      root.style.setProperty('--max-pct', `${maxPct}%`);

      if (minOut) minOut.textContent = formatMoney(symbol, a);
      if (maxOut) maxOut.textContent = formatMoney(symbol, b);

      realMin.value = String(a);

      // If max thumb is at the end, treat it as "no max" (Shopify behavior)
      if (b >= max) {
        realMax.value = '';
      } else {
        realMax.value = String(b);
      }
    }

    // Initial
    clampAndPaint();

    // Slider -> inputs
    minRange.addEventListener('input', () => {
      clampAndPaint();
      realMin.dispatchEvent(new Event('change', { bubbles: true }));
    });

    maxRange.addEventListener('input', () => {
      clampAndPaint();
      realMax.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.facet-price-slider').forEach(initOne);
  }

  document.addEventListener('DOMContentLoaded', () => initAll(document));

  // Facets re-render via section rendering; re-init after updates
  const root = document.querySelector('#FacetFiltersForm') || document.body;
  const mo = new MutationObserver(() => initAll(document));
  mo.observe(root, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', () => initAll(document));
})();
